/* eslint-disable react/no-unused-class-component-methods */
'use strict';

import React, { Component } from 'react'

import { priceFromCents, getCartTotal, isTrue } from '@root/utility'

import { handleChange } from '@/Form/Functions/eventsHandling'
import getFormStatus    from '@/Form/Functions/getFormStatus'

import FormElement from '@/Form/toolkit/FormElement'

import Link from '@Pure/Link'

import CartTotal from '@/CartTotal'

import { safeNumeral, formatNum, cleanNumber, num } from '@root/utility'

const numeral = window.numeral;

numeral.locale('en');

const { app, qwest } = window;

export default class CartPreview extends Component
{
	state =
	{
		form_data: { },
		status_messages: { },
		cart: [],
		places: []
	};

	handleChange = handleChange.bind(this);

	componentDidMount ()
	{
		const component = this, props = this.props, state = this.state;

		app.push(
		{
			event: 'cartChange',
			cb: component.handleCartChange
		});

		app.push(
		{
			event: 'order_processChange',
			cb: component.handleOrderProcessChange
		});

		app.push(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});

		app.push(
		{
			event: 'orderProcessErrorsUpdate',
			cb: component.handlePaymentError
		});

		app.push(
		{
			event: 'serverOrderProcessUpdate',
			cb: component.initValues
		});

		component.setState(
		{
			cart: app.state.cart || []
		});

		if (app.state.order_process?.fetched)
		{
			component.initValues();
		}
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props, state = this.state;

		app.delete(
		{
			event: 'cartChange',
			cb: component.handleCartChange
		});

		app.delete(
		{
			event: 'order_processChange',
			cb: component.handleOrderProcessChange
		});

		app.delete(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});

		app.delete(
		{
			event: 'orderProcessErrorsUpdate',
			cb: component.handlePaymentError
		});

		app.delete(
		{
			event: 'serverOrderProcessUpdate',
			cb: component.initValues
		});

		if (component.comment_timeout)
		{
			window.clearTimeout(component.comment_timeout);
		}
	}

	initValues = () =>
	{
		const component = this, props = this.props, state = this.state;

		numeral.locale('en');

		const update = { };

		if (state.comment === undefined)
		{
			update.comment = app.state.order_process.comment || '';
		}

		if (state.cgv === undefined)
		{
			update.cgv = isTrue(app.state.order_process.cgv);
		}

		if (state.virtual_warning === undefined)
		{
			update.virtual_warning = isTrue(app.state.order_process.virtual_warning);
		}

		if (state.cgv_error === undefined)
		{
			update.cgv_error = isTrue(app.state.order_process.cgv_error);
		}

		if (state.user_abondement_value === undefined)
		{
			update.user_abondement_value = formatNum(
				app.state.order_process.user_abondement, '0[.]00'
			);
		}

		component.setState(update);

		const filter_query =
		{
			id: app.state.cart.reduce(function (ids, item)
			{
				return ids.concat(item.places);
			},
			[])
		};

		qwest.post('/CMS/getAll',
		{
			model: 'place',
			filter_query: JSON.stringify(filter_query)
		})
		.then(function (xhr, response)
		{
			component.setState(
			{
				places: response.data || [],
				loading: false
			});
		})
		.catch(function (error, xhr, response)
		{
			app.ajaxRedirectLogin(response);

			console.error(error);
		});
	}

	handlePaymentError = (data) =>
	{
		const component = this, props = this.props, state = this.state;

		const cgv_error = (app.state.order_process.errors || { }).CGV?.error;

		const products_error = (app.state.order_process.errors || { }).products?.error;

		const virt_warning_error = (app.state.order_process.errors || { })
		.VirtualWarning?.error;

		component.setState(
		{
			error: data.response.error,
			cgv_error: cgv_error,
			virt_warning_error: virt_warning_error,
			products_error: products_error
		});

		if (data.response.E_CODE === 'NOT_ENOUGH_ABONDEMENT')
		{
			app.state.session.EC.abondement = data.response.E_DATA.EC_abondement;

			app.emit('sessionChange');
		}
		else if (data.response.E_CODE === 'NOT_ENOUGH_U_ABONDEMENT')
		{
			app.state.session.abondement ||= { };

			app.state.session.abondement.value = num(
				data.response.E_DATA.user_abondement
			);

			app.emit('sessionChange');
		}
	}

	handleSessionChange = () =>
	{
		const component = this, props = this.props, state = this.state;

		if (typeof app.state.session.user_abondement === 'undefined') return;

		if (!app.state.session.EC) return;

		let shipping_method = app.state.order_process.shipping['shipping[method]'];

		const update =
		{
			shipping_method: shipping_method,
			user_abondement: app.state.session.user_abondement,
			EC_abondement: app.state.session.EC.abondement
		};

		component.setState(update);
	}

	handleOrderProcessChange = ({ source, ...params }) =>
	{
		const component = this, props = this.props, state = this.state;

		if (source === 'CartPreview') return;

		if (state.user_abondement_value > 0 === false) return;

		const cart_total = getCartTotal();

		const max_abondable = numeral(safeNumeral(cart_total.cart_cost))
		.add(safeNumeral(cart_total.shipping_cost))
		.subtract(safeNumeral(cart_total.product_abondement))
		.value();

		if (app.state.order_process.user_abondement > max_abondable)
		{
			app.state.order_process.user_abondement = numeral(max_abondable).value();

			component.setState(
			{
				user_abondement_value: numeral(max_abondable).format('0[.]00')
			});

			app.emit('order_processChange', { source: 'CartPreview' });
		}
	}

	handleCartChange = () =>
	{
		const component = this, props = this.props;

		component.setState({ cart: app.state.cart });
	}

	updateAbondement = (e) =>
	{
		const component = this, props = this.props, state = this.state;

	// Did mount
		if (state.user_abondement_value === undefined && !e) return;

		numeral.locale('en');

		let available_abondement = app.state.session.user_abondement
		? formatNum(app.state.session.user_abondement.value, '0[.]00')
		: undefined;

		let new_value = '';

		if (e === 'less')
		{
			if (state.user_abondement_value > 0 === false) return;

			new_value = numeral(
				safeNumeral(state.user_abondement_value)
			)
			.subtract(1)
			.format('0[.]00');
		}
		else if (e === 'more')
		{
			if (available_abondement !== undefined &&
				Number(state.user_abondement_value) >= available_abondement)
			{
				return;
			}

			new_value = numeral(
				safeNumeral(state.user_abondement_value)
			)
			.add(1)
			.format('0[.]00');
		}
		else if (e)
		{
			new_value = cleanNumber(
			{
				number: e.target?.value,
				positive: true,
				digits: '2',
				max: available_abondement
			});
		}

		const cart_total = getCartTotal();

		const max_abondable = numeral(safeNumeral(cart_total.cart_cost))
		.add(safeNumeral(cart_total.shipping_cost))
		.subtract(safeNumeral(cart_total.product_abondement))
		.value();

		if (max_abondable < new_value)
		{
			new_value = numeral(max_abondable).format('0[.]00');
		}

		if (new_value < 0)
		{
			new_value = '0';
		}

		component.setState(
		{
			user_abondement_value: new_value
		});

		app.state.order_process.user_abondement = numeral(safeNumeral(new_value))
		.value();

		if (e)
		{
			app.emit('order_processChange', { source: 'CartPreview' });
		}
	}

	handleCommentChange = (e) =>
	{
		const component = this, props = this.props, state = this.state;

		if (component.comment_timeout)
		{
			window.clearTimeout(component.comment_timeout);
		}

		component.comment_timeout = window.setTimeout(function ()
		{
			app.emit('order_processChange', { source: 'CartPreview' });
		},
		440);

		component.setState({ comment: e.target.value || '' });

		app.state.order_process.comment = e.target.value || '';
	}

	handleCGVChange = (e, data) =>
	{
		const component = this, props = this.props, state = this.state;

	// checkbox Did mount
		if (!e) return;

		if (component.cgv_timeout)
		{
			window.clearTimeout(component.cgv_timeout);
		}

		component.cgv_timeout = window.setTimeout(function ()
		{
			app.emit('order_processChange', { source: 'CartPreview' });
		},
		440);

		component.setState(
		{
			cgv: isTrue(data?.value),

			cgv_error: undefined
		});

		app.state.order_process.cgv = isTrue(data?.value);
	}

	handleVirtualWarningChange = (e, data) =>
	{
		const component = this, props = this.props, state = this.state;

	// checkbox Did mount
		if (!e) return;

		if (component.virtual_warning_timeout)
		{
			window.clearTimeout(component.virtual_warning_timeout);
		}

		component.virtual_warning_timeout = window.setTimeout(function ()
		{
			app.emit('order_processChange', { source: 'CartPreview' });
		},
		440);

		component.setState(
		{
			virtual_warning: isTrue(data?.value),

			virt_warning_error: undefined
		});

		app.state.order_process.virtual_warning = isTrue(data?.value);
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		numeral.locale('en');

		let items_header =
		(
			<div className="c-cart-preview__item c-cart-preview__item-header">
				<div className="c-cart-preview__item-name">
					Nom du produit
				</div>

				<div className="c-cart-preview__stroke" />

				<div className="c-cart-preview__pricing">

					<div className="c-cart-preview__qty">
						Quantité
					</div>

					<div className="c-cart-preview__pricing-stroke" />

					<div className="c-cart-preview__price">
						Prix total
					</div>

				</div>

			</div>
		);

		let items = component.state.cart
		.filter(item => Boolean(item.cart_price))
		.map(function (item, index)
		{
			let position    = item.cart_price._position;
			let age         = item.cart_price._age;
			let ticket_type = item.cart_price._ticket_type;
			let place;

			if (item._places && item.places.length < 2)
			{
				place = state.places.find(place => place.id === item.places[0]);
			}

			let more_infos;

			if (position || age || ticket_type)
			{
				more_infos = '';

				if (position && position.label)
				{
					more_infos += ' (' + position.label;

					if (age)
					{
						more_infos += ', ';
					}
					else
					{
						more_infos += ')';
					}
				}

				if (age && age.label)
				{
					if (!position)
					{
						more_infos += ' (';
					}

					more_infos += age.label + ')';
				}

				if (ticket_type && ticket_type.label)
				{
					if (more_infos.length > 0)
					{
						more_infos = more_infos.slice(0, more_infos.length-1);

						more_infos += ', ';
					}
					else
					{
						more_infos += ' (';
					}

					more_infos += ticket_type.label;

					more_infos += ')';
				}

				if (place && (place.name || (place.address && place.address.city)))
				{
					if (more_infos.length > 0)
					{
						more_infos = more_infos.slice(0, more_infos.length-1);

						more_infos += ', ';
					}

					more_infos += (place.address.city.slice(0, 1).toUpperCase() +
						place.address.city.slice(1).toLowerCase()) || place.name;

					more_infos += ')';
				}
			}

			let output =
			(
				<div className="c-cart-preview__item" key={ index }>
					<div className="c-cart-preview__item-name">
						{ app.getTruncatedText(item.name, 22) }
						{ ' - ' }
						{ priceFromCents(item.cart_price.price) }
						&nbsp;€
						{ more_infos }
					</div>

					<div className="c-cart-preview__stroke" />

					<div className="c-cart-preview__pricing">

						<div className="c-cart-preview__qty">
							{ 'x ' + item.cart_qty }
						</div>

						<div className="c-cart-preview__pricing-stroke" />

						<div className="c-cart-preview__price">
							{ priceFromCents(item.cart_price.price * item.cart_qty) }
							{ ' €' }
						</div>

					</div>

				</div>
			);

			return output;
		});

		const cart_total = getCartTotal();

		let shipping_price = safeNumeral(cart_total.shipping_cost);

		if (shipping_price > 0 === false)
		{
			shipping_price = 'Offert';
		}
		else
		{
			shipping_price += ' €';
		}

		let shipping =
		(
			<div className="c-cart-preview__item">
				<div className="c-cart-preview__item-name">
					Livraison
				</div>

				<div className="c-cart-preview__stroke" />

				<div className="c-cart-preview__pricing" style={ { minWidth: '0' } }>

					<div className="c-cart-preview__price">
						{ shipping_price }
					</div>

				</div>

			</div>
		);

		let abondement = safeNumeral(cart_total.product_abondement);

		if (abondement > 0)
		{
			abondement =
			(
				<>

					<div className="c-order-process__separator" />

					<div className="c-cart-preview__item">
						<div className="c-cart-preview__item-name">
							Abondement catalogue
						</div>

						<div className="c-cart-preview__stroke" />

						<div className="c-cart-preview__pricing"
							style={ { minWidth: '0' } }>

							<div className="c-cart-preview__price">
								{ '-' + formatNum(abondement, '0,0[.]00') + ' €' }
							</div>

						</div>

					</div>

				</>
			);
		}
		else
		{
			abondement = undefined;
		}

		let max_abondement = '0.00', abondement_qty;

		if (app.state.session.user_abondement)
		{
			max_abondement = formatNum(
				app.state.session.user_abondement.value, '0.00'
			);
		}

		if (max_abondement > 0)
		{
			abondement_qty =
			(
				<div className="c-qty c-qty--cart">

					<button type="button" className="c-qty__less"
						onClick={ e => component.updateAbondement('less') }>
						-
					</button>

					<input type="text" className="c-qty__input"
						min="0" value={ state.user_abondement_value || '' }
						onChange={ component.updateAbondement }
					/>

					<button type="button" className="c-qty__more"
						onClick={ e => component.updateAbondement('more') }>
						+
					</button>

				</div>
			);
		}

		let user_abondement_separator;

		if (typeof abondement === 'undefined')
		{
			user_abondement_separator =
			(
				<div className="c-order-process__separator" />
			);
		}

		let user_abondement =
		(
			<>

				{ user_abondement_separator }

				<div className="c-cart-preview__item center">

					<div className="c-cart-preview__item-name">
						Abondement personnel&nbsp;:
						{
							' ' + formatNum(max_abondement, '0,0[.]00')
						}
						&nbsp;€
					</div>

					<div className="c-cart-preview__stroke" />

					<div className="c-cart-preview__pricing u-margin-right-10"
						style={ { minWidth: '0' } }>

						<div className="c-cart-preview__price">
							{ abondement_qty || undefined }
						</div>

					</div>

					{ formatNum(state.user_abondement_value, '0,0[.]00') }

				</div>

			</>
		);

		if (state.user_abondement_value > 0 === false && !abondement_qty)
		{
			user_abondement = undefined;
		}

		const has_virtual_product = (component.state.cart || [])
		.some(item => isTrue(item.cart_onlineTicket));

		let output =
		(
			<div className="c-order-process__step">

				<h2 className="c-order-process__title">
					<span className="c-order-process__title-number">4</span>
					Récapitulatif
				</h2>

				<div className="u-full-width u-text-right u-positioned">
					<Link className="c-btn c-btn--prev c-order-process__back-cart" href="/panier">
						Modifier mon panier
					</Link>
				</div>

				<div className="c-cart-preview">

					{ items_header }

					{ items }

					{ shipping }

					{ abondement }

					{ user_abondement }

					<CartTotal source="cart-preview" />

				</div>

				{ getFormStatus({ error: state.products_error }) }

				<div className="c-order-process__comment">

					<label className="c-form-label c-form-label--text"
						htmlFor="order-comment">
						Commentaire
					</label>

					<textarea className="c-form__input"
						onChange={ component.handleCommentChange }
						value={ state.comment } name="order-comment"
						id="order-comment"
					/>

				</div>

				<div className="c-order-process__cgv">
					<FormElement type="checkbox" name="cgv"
						label="J'accepte les conditions générales de vente"
						onChange={ component.handleCGVChange }
						data={ state }
						status={ state.status_messages }
						className="u-margin-top-0 u-positioned"
					/>
				</div>

				{
					has_virtual_product ?
					(
						<div className="c-order-process__virtual-info">
							<FormElement type="checkbox" name="virtual_warning"
								label="J'ai noté que pour récupérer mes billets électroniques et/ou suivre les envois je dois me reconnecter sur mon compte et cliquer sur ma commande"
								onChange={ component.handleVirtualWarningChange }
								data={ state }
								status={ state.status_messages }
								className="u-margin-top-0 u-positioned"
							/>
						</div>
					)
					: undefined
				}

				{ getFormStatus(state) }

				{
					state.cgv_error
					? getFormStatus({ error: state.cgv_error })
					: undefined
				}
				{
					state.virt_warning_error
					? getFormStatus({ error: state.virt_warning_error })
					: undefined
				}

				{ props.children }

			</div>
		);

		return output;
	}
}